/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map } from 'immutable';

export const scrollReducer = (state = Map(), action) => {
  switch (action.type) {
    case 'SAVE_SCROLL_POSITION':
      return state.set(action.page, action.location);
    case 'DEAL_SAVING_SUCCESS':
      return state.set(`${action.dealType}1`, 0);
    default:
      return state;
  }
};
export const saveScrollPosition = (dispatch, page, location) =>
  dispatch({ type: 'SAVE_SCROLL_POSITION', page, location });
